import { useEffect, useState } from "react";
import { BasicPage } from "../theme/Component/BasicPage";
import { AccountEditor } from "../editor/AccountEditor";
import { PrintJson } from "../theme/Component/PrintJson";
import { SelectProject } from "../erp/cellEditor/BudgetAccountantOperation/SelectProject";
import { BasicButton } from "../theme/Component/BasicButton";
import useDataBean from "../../core/services/dataBean/useDataBean";
import { _BudgetRPFactory, _single } from "../../core/services/dataBean/EntityCatalog";
import { YearSelector } from "../../core/shared/inputs/YearSelector";
import usePaginator from "../theme/Component/usePaginator";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../theme/Component/BasicTable";
import { DropDown } from "../theme/Component/DropDown";
import useModal, { MODAL_SM } from "../theme/Component/hooks/useModal";
import { Modal } from "../theme/Component/Modal";
import { ExportXLSL } from "../theme/Component/ExportXLSX";


export const BudgetRPReport = () => {

    const paginador = usePaginator();
    const [year, setYear] = useState<number>(new Date().getFullYear());
    const _budget = useDataBean(_BudgetRPFactory);
    const [listaXLS, setListaXLS] = useState<any>([]);
    const { lista, setLista, bean, setBean } = _budget;
    const [filter, setFilter] = useState<any>({});
    const modalXLS = useModal("Detallado", MODAL_SM);

    useEffect(() => {
        handleSearch();
    }, [filter, paginador.page])

    const handleSearch = async () => {
        _budget.instance.getRecordBudgetContractRender(paginador.page, 15, year, _single.cleanMap(filter)).then((resp: any) => {
            setLista(resp.List);
            paginador.setPages(resp.NumberOfPages);
        })
    }
    const handleExportXLS = async () => {
        _budget.instance.getRecordBudgetContractRender(paginador.page, paginador.pages * 15, year, _single.cleanMap(filter)).then((resp: any) => {
            setListaXLS(resp.List);
        })
    }
    const head = [
        { title: 'ID PAA', property: 'IDAdquisitionItem', visible: false, mask: MASK_NUMBER },
        { title: 'Fecha RP', property: 'DocumentDate', visible: true, mask: MASK_DATE },
        { title: 'Documento', property: 'Mnemonic', visible: true },
        { title: 'Consecutivo', property: 'Consecutive', visible: true, mask: MASK_NUMBER },
        { title: 'Valor', property: 'Value', visible: true, mask: MASK_MONEY },
        { title: 'Nit RP', property: 'NitAccountRP', visible: true, mask: MASK_NUMBER },
        { title: 'Tercero RP', property: 'AccountRP', visible: true },
        { title: 'No. Contrato', property: 'InternalCode', visible: true },
        { title: 'Codigo Proyecto', property: 'ProjectCode', visible: true },
        { title: 'Proyecto', property: 'ProjectName', visible: true },
        { title: 'Modalidad', property: 'ModalityName', visible: true },
    ]

    const actionsDropDown = [
        { id: 1, name: 'Descargar Detallado', permiso: null, activo: true }
    ];
    const buttons = () => {
        return (
            <div className="row">
                {lista.length > 0 &&
                    <div className="col-md-12">
                        <DropDown lista={actionsDropDown} eventClick={(e) => {
                            if (e.id === 1) {
                                modalXLS.open();
                                handleExportXLS();
                            }

                        }}></DropDown>
                    </div>
                }
            </div>
        )
    }

    return (
        <BasicPage titulo="Reporte Registro Presupuestal">
            <div className="row">
                <div className="col-md-2">
                    <YearSelector value={year} onChange={(e) => { setYear(e) }} />
                </div>
                <div className="col-md-4">
                    <AccountEditor idAccount={filter.IDAcccount} label="Tercero" onChange={(e: any) => {
                        setFilter({
                            ...filter,
                            IDAccount: e.IDAccount
                        })
                    }} />
                </div>
                <div className="col-md-4">
                    <SelectProject label="Proyecto" idSelector={filter.IDProject} returnType="ID" onChange={(e: any) => {
                        setFilter({
                            ...filter,
                            IDProject: e
                        })
                    }} />
                </div>
                <div className="col-md-4">
                    <BasicButton useMargin icon="ri-search-line" eventClick={handleSearch} >Buscar</BasicButton>
                    <BasicButton useMargin icon="ri-refresh-line" clase="danger" eventClick={() => {
                        setFilter({})
                    }} >Limpiar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable
                        head={head}
                        body={lista}
                        headButtons={buttons()}
                        rowSet={setBean}
                        pageTop={paginador.page}
                        next={paginador.next}
                        back={paginador.back}
                        records={paginador}
                    />
                    <Modal modal={modalXLS.modal} updateModal={modalXLS.setModal}>
                        <ExportXLSL customName={`registro_presupuestal_${_single.getRandomInt()}`} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listaXLS} onExport={(name: string) => {
                            _single.download("formato xlsx [" + name + "] con " + listaXLS.length + " registros");
                            modalXLS.close();
                        }} />
                    </Modal>
                </div>
                {/* <div className="col-md-12">
                    <PrintJson json={lista} />
                </div> */}
            </div>
        </BasicPage>
    );
}